import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=9cd8ec5a&"
import script from "./AboutBanner.vue?vue&type=script&lang=js&"
export * from "./AboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=9cd8ec5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports